// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251045/js/" + chunkId + "." + {"44":"6acdf598","225":"45803b8a","481":"af58c009","486":"ce43875c","770":"da61a594"}[chunkId] + ".0.5634675292913031.chunk.js";
};